import packageJson from "../../../../package.json";

export default function PreviewAppVersionNumber() {
    // Used in HomeDrawerBottomSection

    // BUILD
    return (
        <div className={"flex justify-center items-center mt-[2px]"}>
            <span className={"text-[12px] text-greyLight5 font-normal"}>
                ({packageJson.version})
            </span>
        </div>
    );
}